<template>
  <section class="long-list">
    <PullRefresh v-model="state.refreshing" @refresh="onRefresh">
      <List
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <template v-if="type === 'article'">
          <mLongListArticleItem v-for="item in state.list" :key="item.id" :item="item" />
        </template>
        <template v-else-if="type === 'complaint'">
          <mLongListComplaintItem v-for="item in state.list" :key="item.id" :item="item" />
        </template>
        <template v-else>
          <Skeleton title :row="6" v-for="item in state.list" :key="item.id" />
        </template>
      </List>
    </PullRefresh>
  </section>
</template>
<script>
import { reactive, watch } from 'vue'
import { useRoute } from 'vue-router'

import { List, PullRefresh, Skeleton } from 'vant'
import 'vant/es/list/style'
import 'vant/es/pull-refresh/style'
import 'vant/es/skeleton/style'

export default {
  name: 'mLongList',
  components: { List, PullRefresh, Skeleton },
  props: {
    getData: {
      type: Function,
      default: () => ({ list: [], count: 0, page: 0, pageSize: 10 })
    },
    params: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'article'
    }
  },
  setup (props) {
    const route = useRoute()

    const state = reactive({
      list: [],
      page: 0,
      pageSize: 10,
      count: 0,
      loading: false,
      finished: false,
      refreshing: false
    })
    const onLoad = async () => {
      if (state.refreshing) {
        state.refreshing = false
      }
      const { list = [], count = 0, page = 0, pageSize = 10 } = await props.getData({ ...props.params, page: state.page })
      state.list = [...state.list, ...list]
      state.count = count
      state.page = page + 1
      state.pageSize = pageSize
      state.loading = false
      if (list.length < pageSize) {
        state.finished = true
      }
    }
    const onRefresh = () => {
      // 清空列表数据
      state.finished = false
      state.list = []
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      state.loading = true
      state.page = 0
      onLoad()
    }
    watch(() => route.path, () => {
      onRefresh()
    })
    return {
      state,
      onLoad,
      onRefresh
    }
  }
}
</script>
